import React from 'react'
import classNames from 'classnames'

export default
function ValidationInfo({ isValid }) {
  return isValid !== undefined
    ? (
      <span
        className={classNames({
          validation: true,
          valid: isValid.valid
        })}
      />
    )
    : null
}



// WEBPACK FOOTER //
// ./src/shared/components/ValidationInfo.js